import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'

axios.defaults.headers.post['X-CSRFToken'] = document.querySelector('meta[name="hh"]').getAttribute('content')
Vue.prototype.$http = axios
Vue.config.productionTip = false

Vue.use(ElementUI, { locale })

router.beforeEach((to, from, next) => {
  if (to.fullPath.includes('#')) {
    next(to.fullPath.replace('#', '%23'))
  } else {
    next()
  }
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
